export class BillingPortalProps{
    aud: string = "7c034653-e9a0-46bd-ac66-b4e3447a3ed2";
    customerIds: Array<string> = new Array<string>();
    bans: Array<string> = new Array<string>();
    lumenGlobysID: string = '';
    permissions: Array<string> = new Array<string>();
    firstName: string = '';
    lastName: string = '';
    phoneNumber: string = '';
    sessionId: string = '';
    userEmail: string = '';
}
